import React, { useState } from "react";
import Step1 from "./Stepper/step1";
import Step2 from "./Stepper/step2";
import Step3 from "./Stepper/step3";
import Step4 from "./Stepper/step4";
import Step5 from "./Stepper/step5";
import Step6 from "./Stepper/step6";
import Step7 from "./Stepper/step7";
import Review from "./Stepper/review";

import AidRequest from "./Stepper/aidRequest";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import Logo from "../assets/idea-logo.png";

import "bootstrap/dist/css/bootstrap.min.css";
import "./Stepper/form.css";

import axios from "axios";
import Alerts from "../helper/Alert";
import SuccessDialog from "../helper/SuccessDialog";

const formatUSPhone = (phone) => {
  if (!phone) return "";
  let cleaned = String(phone).replace(/\D/g, "");
  
  if (cleaned.length === 12 && cleaned.startsWith("91")) {
    cleaned = cleaned.substring(2);
  }
  if (cleaned.length === 11 && cleaned.startsWith("1")) {
    cleaned = cleaned.substring(1);
  }

  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `+1 (${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phone;
};

export default function VerticalStepper(props) {
  //modalBox
  // const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);
  //

  const [loading, setLoading] = useState(false);
  // const [returnFileUrls, setReturnFileUrls] = useState([]);
  const [applicantId, setApplicantId] = useState("");
  // const [fileFolderName, setFileFolderName] = useState("");

  const [alert, setAlert] = React.useState({
    open: false,
    message: "",
    severity: "",
  });

  const isIndianPhone = props.memberData?.phoneNumber?.startsWith('+91');

  // const [errors, setErrors] = useState({});
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    //other Details
    submittername: "",
    submitterphonenumber: "",
    // step1
    firstName: "",
    lastName: "",
    email: "",
    phonenumber: "",
    dob: "",
    address: "",
    city: "",
    state: "Tamil Nadu",
    district: "",
    zip: "",
    AadharNumber: "",
    aadharCardFront: "",
    aadharCardBack: "",
    passportSizePhotoFile: "",
    marksheetsFile: "",
    // step2

    fatherName: "",
    fatherOccupation: "",
    motherName: "",
    motherOccupation: "",
    familyCount: "",
    familyIncome: "",
    proofOfIncomeFile: "",

    // step3
    referralName: isIndianPhone ? `${props.memberData.firstName} ${props.memberData.lastName}` : "",
    referralPhone: isIndianPhone ? props.memberData.phoneNumber : "",
    referralEmail: isIndianPhone ? props.memberData.email : "",
    relationtoapplicant: "",
    referralTelephone: "",
    contactType: "mobile",
    // step4
    volunteerName: (!isIndianPhone && props.memberData) ? `${props.memberData.firstName} ${props.memberData.lastName}` : "",
    volunteerEmail: (!isIndianPhone && props.memberData) ? props.memberData.email : "",
    volunteerPhone: (!isIndianPhone && props.memberData) ? formatUSPhone(props.memberData.phoneNumber) : "",
    usaReferenceLetter: "",
    //aid request
    amountRequested: null,
    aidtype: "",
    courseType: "",
    reasonForRequesting: "",
    yearsofsupportisneeded: "",
    multipleyears: "",
    //step5
    institutionName: "",
    institutionMobileNumber: "",
    institutionEmail: "",
    institutionAddress: "",
    institutionCity: "",
    institutionState: "Tamil Nadu",
    institutionZip: "",
    beneficiaryName: "",
    beneficiaryPhone: "",
    accountNumber: "",
    ifscCode: "",
    bankName: "",
    branchName: "",
    paymentAddress: "",
    bonafideCertificate: "",
    //step6
    questions1: "",
    // familyCount: "",
    //step7
    termsAndConditions: false,
    MSEDLetter: "",
  });

  const [activeStep, setActiveStep] = React.useState(0);
  const [updateApplicantDetails, setUpdateApplicantDetails] = React.useState(false);

  // const fileSelected = (index, event) => {
  //   const file = event.target.files[0];
  //   const updatedFiles = [...files];
  //   updatedFiles[index] = file;
  //   setFiles(updatedFiles);
  // };
  const API_URL = process.env.React_App_Api;
  const postForm = async () => {
    try {
      setLoading(true);

      // Always read the latest applicantId from localStorage to avoid stale state
      let resolvedApplicantId = applicantId;
      if (!resolvedApplicantId) {
        const myData = localStorage.getItem('myUsaDatastep1');
        if (myData) {
          resolvedApplicantId = JSON.parse(myData)?.step1?.id;
        }
      }
      if (!resolvedApplicantId) {
        const volunteersDetail = localStorage.getItem('volunteersDetail');
        if (volunteersDetail) {
          resolvedApplicantId = JSON.parse(volunteersDetail)?.volunteersDetail?.id;
        }
      }

      if (!resolvedApplicantId) {
        throw new Error('Applicant ID not found. Please restart the application form.');
      }

      console.log('[postForm] Submitting with applicantId:', resolvedApplicantId);
      const data = {
        reviewcomments: "string",
        committeenotes: "",
        financecommitteenotes: "string",
        username: formData.firstName + formData.lastName,
        submittername: "string",
        submitterphonenumber: formData.phonenumber,
        comments: "",
        status: "new",
        qrOwnerId: props?.qrOwnerId,
       
        questions: {
          answer: "string",
        },
        parentorguardian: {
          fathername: formData.fatherName,
          fatherprofession: formData.fatherOccupation,
          mothername: formData.motherName,
          motherprofession: formData.motherOccupation,
          familyincomepm: formData.familyIncome,
          familyCount: formData.familyCount,
        },
        aidinformation: {
          amtrequested: formData.amountRequested,
          reasonforrequesting: formData.reasonForRequesting,
          aidtype: formData.aidtype,
          courseType: formData.courseType,
          multipleyears: formData.multipleyears,
          finalYearOfPassing: formData.finalYearOfPassing || null,
        },

        institutiondetails: {
          name: formData.institutionName,
          mobileNumber: formData.institutionMobileNumber,
          email: formData.institutionEmail,
          address: formData.institutionAddress,
          city: formData.institutionCity,
          state: formData.institutionState,
          district: formData.institutiondistrict,
          pincode: formData.institutionZip,
          website: "string",
        },
        paymentmethod: {
          ifsccode: formData.ifscCode,
          accountnumber: formData.accountNumber,
          bankname: formData.bankName,
          branchname: formData.branchName,
          branchAddress: formData.paymentAddress,
          beneficiaryname: formData.beneficiaryName,
          beneficiaryphone: formData.beneficiaryPhone,
        },
      };
      if (formData.multipleyears === "yes") {
        data.aidinformation.yearsofsupportisneeded =
          formData.yearsofsupportisneeded;
      }
      await axios
        .put(`${API_URL}/aid/newupdate/${resolvedApplicantId}`, data)
        .then((res) => {
          localStorage.removeItem("myUsaDatastep1");
          localStorage.removeItem("volunteersDetail");
          setOpen(true);
        })
        .catch((error) => {
          if (error.response) {
            switch (error.response.status) {
              case 404:
                // Applicant document was deleted (e.g. QR limit exceeded in a previous attempt)
                // Clear stale localStorage so the user can restart the form fresh
                localStorage.removeItem('myUsaDatastep1');
                localStorage.removeItem('volunteersDetail');
                throw new Error(
                  'Your application session has expired or was removed. Please refresh the page and restart the application form.'
                );
              case 403:
                // QR limit exceeded — the backend also deletes the document, so clear localStorage
                localStorage.removeItem('myUsaDatastep1');
                localStorage.removeItem('volunteersDetail');
                throw new Error(
                  error.response.data?.message ||
                  'QR limit exceeded for this year. Your application could not be submitted.'
                );
              case 409:
                throw new Error("Conflict: Duplicate data detected.");
              case 503:
                throw new Error("Service unavailable. Please try again later.");
              default:
                throw new Error(
                  error.response.data || "Unexpected error occurred."
                );
            }
          } else if (error.message) {
            throw new Error(`Request failed: ${error.message}`);
          } else {
            throw new Error(
              "An unknown error occurred while submitting the form."
            );
          }
        });
    } catch (error) {
      setAlert({
        open: true,
        message: error.message || "An unexpected error occurred.",
        severity: "error",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    } finally {
      setLoading(false); // Set loading state to false when form submission completes (whether success or error)
    }
  };

  const fetchApplicantData = async (applicantId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/aid/applicantDetailsStepData/${applicantId}`);
      const data = response.data;

      // Update form data with fetched values
      setFormData(prev => ({
        ...prev,
        firstName: data.applicant.firstName,
        lastName: data.applicant.lastName,
        email: data.applicant.appemail,
        phonenumber: data.applicant.phonenumber,
        dob: data.applicant.dob,
        address: data.address.addressone,
        city: data.address.city,
        state: data.address.state,
        district: data.address.district,
        zip: data.address.pincode,
        aadharNumber: data.applicant.aadharcardnumber,
        aadharCardFront: data.applicant.aadharCardFront,
        aadharCardBack: data.applicant.aadharCardBack,
        passportSizePhotoFile: data.applicant.passportSizePhotoFile,
        marksheetsFile: data.applicant.marksheetsFile,
        proofOfIncomeFile: data.parentorguardian.proofOfIncomeFile,
        bonafideCertificate: data.institutiondetails.bonafideCertificate,
        usaReferenceLetter: data.usavolunteer.usaReferenceLetter,
        msetScholarshipLetter: data.msetScholarshipLetter
        // Add other fields as needed
      }));

      // You might also want to update files state if needed
    } catch (error) {
      setAlert({
        open: true,
        message: "Failed to fetch applicant data",
        severity: "error",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchReferenceData = async (applicantId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/aid/applicantDetailsStepData/${applicantId}`);
      const data = response.data;

      // Update form data with fetched values
      setFormData(prev => ({
        ...prev,
        volunteerName: data.usavolunteer.usvname,
        volunteerPhone: data.usavolunteer.usvphone,
        volunteerEmail: data.usavolunteer.email,
        referralName: data.indiavolunteer.ivname,
        contactType: data.indiavolunteer.contactType,
        referralEmail: data.indiavolunteer.ivemail,
        referralRelationship: data.indiavolunteer.relationtoapplicant,
        ...(data.indiavolunteer.contactType === "mobile" && {
          referralPhone: data.indiavolunteer.ivphone
        }),
        ...(data.indiavolunteer.contactType === "telephone" && {
          referralTelephone: data.indiavolunteer.ivTelephone
        })
      }));

      // You might also want to update files state if needed
    } catch (error) {
      setAlert({
        open: true,
        message: "Failed to fetch applicant data",
        severity: "error",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    } finally {
      setLoading(false);
    }
  };

  const handleBack = async () => {
    if (activeStep === 3) {
      // When going back from Step 1 to Step 0
      const storedData = localStorage.getItem("myUsaDatastep1");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        await fetchApplicantData(parsedData.step1.id);
        setUpdateApplicantDetails(true);
      }
    } else if (activeStep === 2) {
      // When going back from Step 1 to Step 0
      const storedData = localStorage.getItem("volunteersDetail");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        console.log("PARSEDDATA", parsedData);
        await fetchReferenceData(parsedData.volunteersDetail.id);
      }
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    return setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const steps = [
    {
      label: "USA Reference Details",
      description: (
        <Step4
          formData={formData}
          setFormData={setFormData}
          handleNext={handleNext}
          handleBack={handleBack}
          isVolunteerReadOnly={!isIndianPhone && !!props.memberData}
        />
      ),
    },
    {
      label: "India Reference Details",
      description: (
        <Step3
          formData={formData}
          setFormData={setFormData}
          handleNext={handleNext}
          handleBack={handleBack}
          applicantId={applicantId}
        />
      ),
    },
    {
      label: "Applicant Details",
      description: (
        <Step1
          updateApplicantDetails={updateApplicantDetails}
          setUpdateApplicantDetails={setUpdateApplicantDetails}
          setApplicantId={setApplicantId}
          formData={formData}
          setFormData={setFormData}
          handleNext={handleNext}
          handleBack={handleBack}
        />
      ),
    },
    {
      label: "Parent/Guardian Details",
      description: (
        <Step2
          setApplicantId={setApplicantId}
          formData={formData}
          setFormData={setFormData}
          handleNext={handleNext}
          handleBack={handleBack}
        />
      ),
    },

    {
      label: "Aid Request",
      description: (
        <AidRequest
          formData={formData}
          setFormData={setFormData}
          handleNext={handleNext}
          handleBack={handleBack}
        />
      ),
    },
    {
      label: "Institution Details",
      description: (
        <Step5
          formData={formData}
          setFormData={setFormData}
          handleNext={handleNext}
          handleBack={handleBack}
        />
      ),
    },
    {
      label: "School / College Bank Details",
      description: (
        <Step6
          formData={formData}
          setFormData={setFormData}
          handleNext={handleNext}
          handleBack={handleBack}
        />
      ),
    },
    {
      label: "Acknowledgement & Declaration",
      description: (
        <Step7
          handleNext={handleNext}
          handleBack={handleBack}
          setFormData={setFormData}
          formData={formData}
        />
      ),
    },

    {
      label: "Review",
      description: (
        <Review
          loading={loading}
          formData={formData}
          setFormData={setFormData}
          handleBack={handleBack}
        />
      ),
    },
  ];

  React.useEffect(() => {
    const myData = localStorage.getItem("myUsaDatastep1");
    const volunteersDetail = localStorage.getItem('volunteersDetail');
    if (myData) {
      const storedDataString = localStorage.getItem("myUsaDatastep1");
      const storedData = JSON.parse(storedDataString);

      setApplicantId(storedData.step1.id);
      setActiveStep(3); // Assuming Step1 is completed
    } else if (volunteersDetail) {
      const storedDataString = localStorage.getItem('volunteersDetail');
      const storedData = JSON.parse(storedDataString);
      console.log("STOREDDATA", storedData);
      setApplicantId(storedData.volunteersDetail.id);
      setActiveStep(2);
    } else {
      setActiveStep(0); // Start from the first step
    }
  }, []);

  const handleReset = () => {
    setActiveStep(0);
  };
  const handleCloseAlert = () => {
    setAlert({
      open: false,
      message: "",
      severity: "",
    });
  };
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  return (
    <Box sx={{ p: 2, md: "" }}>
      <Alerts
        open={alert.open}
        message={alert.message}
        severity={alert.severity}
        onClose={handleCloseAlert}
      />
      <SuccessDialog
        open={open}
        setOpen={setOpen}
        multipleYearRequest={false}
      />
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography sx={{ fontSize: "23px", fontWeight: "bold" }}>
          <img
            src={Logo}
            alt="logo"
            width={"37"}
            height={"37"}
          // style={{ marginRight: "40px" }}
          />{" "}
          IDEA Scholarship Application - {currentYear}{" "}
          <img
            src={Logo}
            alt="logo"
            width={"37"}
            height={"37"}
            style={{ marginRight: "40px" }}
          />
        </Typography>
      </Box>

      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel
              optional={
                index === 7 ? (
                  <Typography variant="caption">Last step</Typography>
                ) : null
              }
            >
              {step.label}
            </StepLabel>
            <StepContent>
              {step.description}
              <Box sx={{ mb: 2 }}>
                {index === 8 ? (
                  <Box sx={{ display: "flex" }}>
                    <Button
                      variant="outlined"
                      onClick={handleBack}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Back
                    </Button>{" "}
                    <Button
                      variant="contained"
                      color="success"
                      // onClick={modelBox}
                      onClick={postForm}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Review and Submit
                    </Button>
                  </Box>
                ) : (
                  ""
                )}
              </Box>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length && (
        <Paper square elevation={0} sx={{ p: 3 }}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
            Reset
          </Button>
        </Paper>
      )}
    </Box>
  );
}
